import styled from 'styled-components';
import {
    border,
    color,
    compose,
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight,
    letterSpacing,
    space
} from 'styled-system';
import propTypes from '@styled-system/prop-types';

const style = compose(
    color,
    border,
    space
);

const paragraphStyle = compose(
    fontSize,
    fontStyle,
    fontWeight,
    letterSpacing,
    lineHeight
);

const Blockquote = styled.blockquote`

    ${style}

    p {

        margin-bottom: 0;

        ${paragraphStyle}
    }
`;

Blockquote.propTypes = {
    ...propTypes.border,
    ...propTypes.color,
    ...propTypes.fontSize,
    ...propTypes.fontStyle,
    ...propTypes.fontWeight,
    ...propTypes.lineHeight,
    ...propTypes.letterSpacing,
    ...propTypes.space
};

Blockquote.defaultProps = {
    backgroundColor: '#00008e05',
    borderLeft: '8px solid',
    borderColor: 'text-darkblue',
    color: 'text-grey',
    fontSize: '22px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0.02em',
    marginBottom: 36,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 36,
    paddingBottom: 8,
    paddingLeft: 18,
    paddingRight: 0,
    paddingTop: 8,
};

export default Blockquote;